import {
  Box,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from '@mui/material';
import { generateClient } from 'aws-amplify/api';
import { useEffect, useState } from 'react';
import ReactLoading from 'react-loading';
import { Schema } from '../../../../../amplify/data/resource';
import Item from './Item';

// @ts-ignore
type Agent = Schema['User']['type'];

const apiClient = generateClient<Schema>();

const List: React.FC = () => {
  const theme = useTheme();

  const [agents, setAgents] = useState<Agent[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const sub = apiClient.models.User.observeQuery({
      filter: { role: { eq: 'agent' } },
    }).subscribe({
      next: ({ items, isSynced }: { items: Agent[]; isSynced: boolean }) => {
        setAgents([...items]);
        setLoading(false);
      },
    });
    return () => sub.unsubscribe();
  }, []);

  return (
    <Box sx={{ direction: 'rtl' }}>
      {loading ? (
        <Stack justifyContent="center" alignItems="center" width="100%">
          <ReactLoading
            type={'bubbles'}
            color={theme.palette.green.main}
            height={250}
            width={250}
          />
        </Stack>
      ) : (
        <TableContainer
          component={Paper}
          sx={{
            backgroundColor: 'transparent',
            boxShadow: 'none',
            maxHeight: '600px',
            overflowY: 'auto',
          }}
        >
          <Table
            stickyHeader
            sx={{
              backgroundColor: 'transparent',
              borderCollapse: 'separate',
              borderSpacing: '0 10px',
            }}
          >
            <TableHead>
              <TableRow sx={{ backgroundColor: 'transparent' }}>
                <TableCell
                  sx={{
                    padding: '10px 20px',
                    borderBottom: 'none',
                    textAlign: 'right',
                    backgroundColor: 'transparent',
                  }}
                >
                  <Typography
                    fontSize="14px"
                    fontWeight="700"
                    fontFamily={'AlmoniDL'}
                  >
                    פרטי סוכן
                  </Typography>
                </TableCell>
                <TableCell
                  sx={{
                    padding: '10px 20px',
                    borderBottom: 'none',
                    textAlign: 'right',
                    backgroundColor: 'transparent',
                  }}
                >
                  <Typography
                    fontSize="14px"
                    fontWeight="700"
                    fontFamily={'AlmoniDL'}
                  >
                    פרטי קשר
                  </Typography>
                </TableCell>
                <TableCell
                  sx={{
                    padding: '10px 20px',
                    borderBottom: 'none',
                    textAlign: 'right',
                    backgroundColor: 'transparent',
                  }}
                >
                  <Typography
                    fontSize="14px"
                    fontWeight="700"
                    fontFamily={'AlmoniDL'}
                  >
                    תאריך הצטרפות
                  </Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {agents.map((agent) => (
                <Item key={agent.id} agent={agent} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

export default List;
